import { useSelector } from 'react-redux';
import { IArticleItem } from '../types/articleItem';
import { State } from 'state/store-types';
import { selectArticleById } from '../reducers/articlesSelectors';

export const useArticlePropsById = (articleId: string): IArticleItem => {
  return useSelector((state: State) => selectArticleById(state, articleId));
};
